// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"f999d9cba195b23bb872","655":"87bd4403918750c77475"}[chunkId] + ".js";
};